module.exports = __webpack_public_path__ + "img/mexico.ef213dbd.jpg";